// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Switch_wrapper__2ihNL"};